import styled from 'astroturf/react'
import { BareButton } from '@calendly/ui/components/bare-button'

import { InviteeCountDisplay, InviteeCounter, ThumbsUpIcon } from '../../styles'

import OutlinedThumbsUp from './icons/thumbs-up-default.svg'
import SolidThumbsUp from './icons/thumbs-up-filled.svg'
import SolidBlueThumbsUp from './icons/thumbs-up-filled-blue.svg'
import _StyledCountButton from "invitee_count_button-StyledCountButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/invitee_count_button.js?styleId=StyledCountButton";
import _StyledThumbsUpIcon from "invitee_count_button-StyledThumbsUpIcon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/invitee_count_button.js?styleId=StyledThumbsUpIcon";
import _StyledInviteeCounter from "invitee_count_button-StyledInviteeCounter.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/invitee_count_button.js?styleId=StyledInviteeCounter";


const StyledCountButton = /*#__PURE__*/styled(BareButton, null, {
  displayName: "StyledCountButton",
  styles: _StyledCountButton
})

const StyledThumbsUpIcon = /*#__PURE__*/styled(ThumbsUpIcon, null, {
  displayName: "StyledThumbsUpIcon",
  styles: _StyledThumbsUpIcon
})

const StyledInviteeCounter = /*#__PURE__*/styled(InviteeCounter, null, {
  displayName: "StyledInviteeCounter",
  styles: _StyledInviteeCounter
})

export const InviteeCountButton = ({ onClick, isSelected, invitees, isFilled = false }) => {
  const selectedThumbsUpIcon = isFilled ? SolidBlueThumbsUp : SolidThumbsUp
  const iconSrc = isSelected ? selectedThumbsUpIcon : OutlinedThumbsUp
  const inviteesCount = invitees.length
  const hasInvitees = invitees.length > 0
  const countText = inviteesCount > 0 ? inviteesCount : <>&nbsp;</>

  return (
    <StyledCountButton onClick={onClick} isFilled={isFilled} data-testid="invitee-vote-button">
      <StyledThumbsUpIcon
        src={iconSrc}
        isSelected={isSelected}
        hasInvitees={hasInvitees}
      />
      <InviteeCountDisplay>
        <StyledInviteeCounter roll={isSelected} visible={!isSelected}>
          {countText}
        </StyledInviteeCounter>
        <StyledInviteeCounter roll={isSelected} visible={isSelected}>
          {countText}
        </StyledInviteeCounter>
      </InviteeCountDisplay>
    </StyledCountButton>
  )
}
